import { useMutation } from '@apollo/client/react';
import { type CompleteServiceExecutionFragment, QueueServiceDocument } from '@drycut/graphql';
import { Button, Stack } from '@drycut/ui-components';
import { ArrowUturnLeftIcon } from '@heroicons/react/20/solid';

type Props = {
  serviceExecution: CompleteServiceExecutionFragment;
};

export default function RequeueServiceButton({ serviceExecution }: Props): React.ReactElement {
  const [holdService, { loading }] = useMutation(QueueServiceDocument);

  const handleClick = async () => {
    await holdService({
      variables: {
        input: {
          serviceExecutionId: serviceExecution.id,
        },
      },
    });
  };

  return (
    <Button
      size="small"
      textClassName="px-0 text-nowrap text-ellipsis overflow-hidden max-w-32"
      loading={loading}
      onClick={handleClick}
    >
      {!loading && (
        <Stack direction="row" gap={1}>
          <ArrowUturnLeftIcon className="w-4 h-4" />
          <span className="sm:hidden xl:flex">Warteschlange</span>
        </Stack>
      )}
    </Button>
  );
}
